// import { ReactComponent as CalendarIcon } from '../../assets/images/calendarIcon.svg';
import { ReactComponent as ChatIcon } from '../../assets/images/chatIcon.svg';
import { ReactComponent as ThumbIcon } from '../../assets/images/thumbIcon.svg';
import { ReactComponent as LockIcon } from '../../assets/images/lockIcon.svg';
import './style.scss';

export const INFO_SECTION_DATA = [
  /* {
    icon: <CalendarIcon />,
    title: 'cart.info.guestCheckout.title',
    description: 'cart.info.guestCheckout.description',
  }, */
  {
    icon: <ChatIcon />,
    title: 'cart.info.needHelp.title',
    description: 'cart.info.needHelp.description',
    linkLabel: 'cart.info.needHelp.linkLabel',
    linkUrl: 'cart.info.needHelp.linkUrl',
  },
  {
    icon: <ThumbIcon />,
    title: 'cart.info.buyerGuaranted.title',
    description: 'cart.info.buyerGuaranted.description',
  },
  {
    icon: <LockIcon />,
    title: 'cart.info.sslProtection.title',
    description: 'cart.info.sslProtection.description',
  },
];
